import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useMotionValue, useSpring } from 'motion/react';

import scrollPositionPropType from '../../propTypes/animations/scrollPosition';

const MotionScrollWrapper = ({ children, scrollPosition, disable = false }) => {
  const [left, setLeft] = useState(scrollPosition.left);
  const [top, setTop] = useState(scrollPosition.top);

  const leftMotion = useMotionValue(left);
  const leftSpring = useSpring(leftMotion, { damping: 50, stiffness: 400 });

  const topMotion = useMotionValue(top);
  const topSpring = useSpring(topMotion, { damping: 50, stiffness: 400 });

  useEffect(() => {
    leftSpring.onChange((value) => setLeft(value));
  }, [leftSpring]);

  useEffect(() => {
    topSpring.onChange((value) => setTop(value));
  }, [topSpring]);

  useEffect(() => {
    leftMotion.set(scrollPosition.left);
  }, [scrollPosition.left, leftMotion]);

  useEffect(() => {
    topMotion.set(scrollPosition.top);
  }, [scrollPosition.top, topMotion]);

  return (
    <div className="sl-motion-scroll-wrapper" data-testid="sl-motion-scroll-wrapper">
      {disable
        ? children
        : React.cloneElement(children, {
            scrollTop: top,
            scrollLeft: left,
            forceScrolling: true,
          })}
    </div>
  );
};

MotionScrollWrapper.propTypes = {
  scrollPosition: scrollPositionPropType.isRequired,
  disable: PropTypes.bool,
};

export default MotionScrollWrapper;
